import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2, Self, Optional } from '@angular/core';
import { NgModel } from '@angular/forms';
import { isIE9 } from '../../../lib/utils';

@Directive({
  selector: 'input[uiInput],textarea[uiInput]',
  host: {
    '[class.ui-form-control]': 'true',
    '[class.ui-input-sm]': 'size === "sm"',
    '[class.ui-input-lg]': 'size === "lg"'
  }
})
export class InputDirective implements OnInit, OnDestroy {
  @Input() size: string;

  private unListen: () => void;

  constructor(@Self() @Optional() private ngModel: NgModel,
              private renderer: Renderer2,
              private elementRef: ElementRef) {
  }

  ngOnInit() {
    if (isIE9 && this.ngModel) {
      this.unListen = this.renderer.listen(this.elementRef.nativeElement, 'blur', () => {
        this.ngModel.update.emit(this.elementRef.nativeElement.value);
      });
    }
  }

  ngOnDestroy() {
    if (this.unListen) {
      this.unListen();
    }
  }
}